import { appConfig } from "src/config";
import { USER_IS_BOT } from "src/utils/botDetector";
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

export function loadOptimizely() {
  const optimizelyProjectId = appConfig.OPTIMIZELY_PROJECT_ID_EN;

  if (USER_IS_BOT) {
    return Promise.resolve();
  }

  return loadScript(
    "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js",
    [LibCategories.functionalCookies]
  ).then(() =>
    loadScript(`https://cdn.optimizely.com/js/${optimizelyProjectId}.js`, [
      LibCategories.functionalCookies,
    ])
  );
}
